import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import Layout from './components/Layout';

// Lazy load all pages
const HomePage = lazy(() => import('./pages/Home'));
const AboutPage = lazy(() => import('./pages/About'));
const CapabilitiesPage = lazy(() => import('./pages/Capabilities'));
const IndustriesPage = lazy(() => import('./pages/Industries'));
const TemperedGlassPage = lazy(() => import('./pages/TemperedGlass'));
const ProjectsPage = lazy(() => import('./pages/Projects'));
const SportingPage = lazy(() => import('./pages/Sporting'));
const OEMAssembliesPage = lazy(() => import('./pages/OEMAssemblies'));
const ThirdPartyLogisticsPage = lazy(() => import('./pages/ThirdPartyLogistics'));
const OutsourcingPage = lazy(() => import('./pages/Outsourcing'));
const InActionPage = lazy(() => import('./pages/WatchUs'));
const CareersPage = lazy(() => import('./pages/Careers'));
const BenefitsPage = lazy(() => import('./pages/Benefits'));
const OpeningsPage = lazy(() => import('./pages/Openings'));
const RequestQuotePage = lazy(() => import('./pages/RequestQuote'));
const ContactPage = lazy(() => import('./pages/Contact'));
const NotFoundPage = lazy(() => import('./pages/NotFound'));

// Sub-pages under Our Story
const EngineeringPage = lazy(() => import('./pages/Engineering'));
const QualityPage = lazy(() => import('./pages/Quality'));
const SafetyPage = lazy(() => import('./pages/Safety'));
const CustomerServicePage = lazy(() => import('./pages/CustomerService'));
const ShippingPage = lazy(() => import('./pages/Shipping'));
const PressPage = lazy(() => import('./pages/Press'));

function PageLoader() {
  return (
    <Center h="60vh">
      <Loader size="lg" color="cyan" />
    </Center>
  );
}

export default function App() {
  return (
    <Layout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-story" element={<AboutPage />} />
          <Route path="/our-story/engineering" element={<EngineeringPage />} />
          <Route path="/our-story/quality" element={<QualityPage />} />
          <Route path="/our-story/safety" element={<SafetyPage />} />
          <Route path="/our-story/customer-service" element={<CustomerServicePage />} />
          <Route path="/our-story/shipping" element={<ShippingPage />} />
          <Route path="/our-story/press" element={<PressPage />} />
          <Route path="/solutions" element={<CapabilitiesPage />} />
          <Route path="/solutions/industries" element={<IndustriesPage />} />
          <Route path="/solutions/tempered-glass" element={<TemperedGlassPage />} />
          <Route path="/solutions/projects" element={<ProjectsPage />} />
          <Route path="/solutions/sporting" element={<SportingPage />} />
          <Route path="/solutions/oem" element={<OEMAssembliesPage />} />
          <Route path="/solutions/3pl" element={<ThirdPartyLogisticsPage />} />
          <Route path="/solutions/outsourcing" element={<OutsourcingPage />} />
          <Route path="/in-action" element={<InActionPage />} />
          <Route path="/join-us" element={<CareersPage />} />
          <Route path="/join-us/benefits" element={<BenefitsPage />} />
          <Route path="/join-us/openings" element={<OpeningsPage />} />
          <Route path="/request-quote" element={<RequestQuotePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}
